module.exports = __webpack_public_path__ + "img/spanishLaLiga.fef35756.png";